import {Heading, Link, River, Text} from '@primer/react-brand'
import type {RiverProps} from '@primer/react-brand'
import {Image, VideoPlayer} from '@primer/react-brand-next'

import {getImageSources} from '@github-ui/swp-core/lib/utils/images'

import {renderWithNoMarks} from '../utils'
import type {LabelAssetLinkItem} from '../../../lib/types/contentful/contentTypes/labelAssetLinkItem'

export type FeaturedStackProps = {
  items?: LabelAssetLinkItem[]
}

const RIVER_ALIGNMENTS: Array<RiverProps['align']> = ['start', 'end']

export const FlexSuiteRiverStack = ({items}: FeaturedStackProps) => {
  if (!items || items.length === 0) return null

  return (
    <>
      {items.map((item, index) => {
        const {heading, description, href, label, assetType, optionImage, optionVideo, optionPoster} = item.fields
        const align = RIVER_ALIGNMENTS[index % RIVER_ALIGNMENTS.length]

        return (
          <River key={item.sys.id} align={align}>
            <River.Visual>
              {assetType === 'Video' && optionVideo ? (
                <VideoPlayer title={optionVideo.fields.description ?? 'Video'} poster={optionPoster?.fields.file.url}>
                  <VideoPlayer.Source src={optionVideo.fields.file.url} type="video/mp4" />
                </VideoPlayer>
              ) : optionImage ? (
                <Image
                  as="picture"
                  src={`${optionImage.fields.file.url}?fm=webp`}
                  sources={getImageSources(optionImage.fields.file.url, {maxWidth: 720})}
                  alt={optionImage.fields.description ?? ''}
                />
              ) : null}
            </River.Visual>
            <River.Content>
              <Heading as="h3" size="5">
                {renderWithNoMarks(heading)}
              </Heading>
              <Text>{renderWithNoMarks(description)}</Text>
              <Link href={href}>{label}</Link>
            </River.Content>
          </River>
        )
      })}
    </>
  )
}
